import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=ef6ccb72&"
import script from "./Hospitals.vue?vue&type=script&lang=js&"
export * from "./Hospitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports